import {WoodType} from "../../../apis/backend";

export const WoodTypeDisplayValues: Record<WoodType, string> = {
    AmericanOak: "American Oak",
    FrenchOak: "French Oak"
}